import { LoadableAfterPaint } from '@confluence/loadable';

export const CopyWithRovoBannerLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CopyWithRovoBanner" */ '../src/CopyWithRovoBanner.tsx'
			)
		).CopyWithRovoBanner,
	loading: () => null,
});
